<template>
  <div>
    <div class="pixPayment" v-if="!showQuoteMessageSuccess">
      <p>
        {{ $t('recharge.pix.description') }}
      </p>

      <img
        alt="PIX QR CODE"
        class="d-block mx-auto"
        height="auto"
        width="300"
        :src="`data:image/jpeg;base64,${pixData.pix_qrcode_image}`"
      />

      <v-divider class="mt-2 mb-8" />

      <v-textarea
        :value="pixData.pix_string_code"
        outlined
        readonly
        small
      />

      <div class="d-flex justify-center">
        <v-chip>
          <v-progress-circular
            :size="10"
            :width="1"
            class="mr-2"
            indeterminate
          />
          {{ $t(`recharge.status.${pixData.status}`) }}
        </v-chip>
      </div>
    </div>

    <div v-else class="pixSuccess">
      <HSuccess />

      <h2 class="text-center mw-300 mx-auto mb-10 green--text">
        {{ $t('quote.hint.paymentSuccess') }}
      </h2>
    </div>
  </div>
</template>

<script>
import HSuccess from '@/components/app/HSuccess'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'QuotePaymentPixSuccess',

  components: {
    HSuccess,
  },

  props: {
    successData: {
      type: Object,
    },

    pixCodeAndQRCode: {
      type: [Object, Boolean],
    },
  },

  computed: {
    ...mapGetters([
      'isQuotePaid',
      'quotePaymentStatus',
      'showQuoteMessageSuccess',
    ]),

    paymentData() {
      if (this.successData) return this.successData?.installments[0]
      return this.pixCodeAndQRCode?.installments[0]
    },

    pixData() {
      return this.paymentData
    },

    status() {
      return this.pixData?.status
    },
  },

  methods: {
    ...mapMutations(['setShowQuoteMessageSuccess']),
    ...mapActions(['refreshPixQuote', 'fetchQuotes']),

    startRefreshInterval() {
      this.ceaseInterval()
      if (this.status === 'OVERDUE') return

      const id = this.pixCodeAndQRCode.id
        ? this.pixCodeAndQRCode.id
        : this.successData.id

      this._interval = setInterval(() => {
        this.checkPaymentStatus()
        this.refreshPixQuote(id).then((response) => response !== 'ASAAS_PIX' && this.ceaseInterval())
      }, 5000)
    },

    checkPaymentStatus() {
      if (
        this.isQuotePaid ||
        this.quotePaymentStatus === 'RECEIVED' ||
        this.quotePaymentStatus === 'CONFIRMED'
      ) {
        this.fetchQuotes(this.$route?.params?.id)
        this.setShowQuoteMessageSuccess(true)
        this.ceaseInterval()
      }
    },

    ceaseInterval() {
      clearInterval(this._interval)
      this._interval = null
    },
  },

  data() {
    return {
      _interval: null,
    }
  },

  mounted() {
    Promise.resolve(this.startRefreshInterval())
  },
}
</script>
